import React from "react";
import { useSelector } from "react-redux";
import SearchableDropdown from "./SearchableDropdown";
import { getDropdownOptions } from "../common";

const LocationSearch = ({
  setLocation,
  location,
  leftIcon = <i className="uil uil-map-marker"></i>,
  labelField = "state",
  valueField = "state",
}) => {
  const jobLocationsReducer = useSelector((state) => state.jobLocations);
  const jobLocations = jobLocationsReducer?.data;

  return (
    <SearchableDropdown
      options={getDropdownOptions(jobLocations, {
        label: labelField,
        value: valueField,
      })}
      value={location}
      onChange={setLocation}
      placeholder="Select Location"
      leftIcon={leftIcon}
      sortOptionsAlphabetically
    />
  );
};


export default LocationSearch;
